import { render, staticRenderFns } from "./BlockList.vue?vue&type=template&id=886456e6&"
import script from "./BlockList.vue?vue&type=script&lang=js&"
export * from "./BlockList.vue?vue&type=script&lang=js&"
import style0 from "./BlockList.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports